module.exports = __webpack_public_path__ + "img/debitcard.b8c362eb.svg";